import { ScenarioMetadata, ScenarioStage } from "../types/scenarioType";

/**
 * The set of scenarios that should be VISIBLE on the project page for a
 * given stage tab + Show-archived toggle: matching stage, and (when the
 * toggle is off) not archived.
 *
 * This is the single source of truth for "what the user can see right
 * now". Both the plotted/aggregated scenario lists AND the chart
 * base-scenario picker must use it — otherwise the picker can anchor to
 * an archived run that isn't plotted, leaving the base marker/reference
 * line pointing at an invisible scenario.
 */
export const filterVisibleScenarios = (
    scenarios: ReadonlyArray<ScenarioMetadata>,
    stage: ScenarioStage,
    showArchived: boolean
): ScenarioMetadata[] =>
    scenarios.filter((s) => s.stage === stage && (!s.archived || showArchived));
